<div class="card tab-box">
    <div class="row user-tabs">
      <div class="col-lg-12 col-md-12 col-sm-12 line-tabs">
        <ul class="nav nav-tabs nav-tabs-bottom">
          <li class="nav-item">
            <button class="nav-link" [class.activetab]= "ishighlighted('potab')" mat-flat-button (click)="poTab()" *ngIf="tabFlag=='PO'">
              <mat-icon>list</mat-icon>
              PO Details </button>
            <button class="nav-link" [class.activetab]= "ishighlighted('potab')" mat-flat-button (click)="poTab()" *ngIf="tabFlag=='RC'">
              <mat-icon>list</mat-icon>
              RC Details </button>
			      <!-- <button class="nav-link" (click)="poTab()" *ngIf="tabFlag=='RC'">RC Details</button> -->
          </li>
          <li class="nav-item">
            <button class="nav-link"  [class.activetab]= "ishighlighted('producttab')" mat-flat-button (click)="productTab()">
              <mat-icon>description</mat-icon>
              Product Details</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" [class.activetab]= "ishighlighted('termstab')" mat-flat-button (click)="poTermsTab()" [disabled]= "additionalTerms">
              <mat-icon>info</mat-icon>
              Terms & Conditions</button>
          </li>
          <!-- <li class="nav-item">
            <button class="nav-link" [class.activetab]= "ishighlighted('paymenttab')" mat-flat-button (click)="paymentScheduleTab()">
              <mat-icon>calendar_today</mat-icon>
              PO Payment Schedule</button>
          </li> -->
          <!-- <li class="nav-item">
            <button class="nav-link preview-btn" (click)="viewPoTab()"> <span class="fa fa-eye"></span> Preview</button>
          </li> -->
        </ul>
      </div>
    </div>
  </div>